<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-form class="mb-3" validate-on="input lazy" @submit.prevent="updateAsset">
            <v-card style="position: relative;">
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>Asset Monitoring Configs</h4>
                    <v-btn density="compact" icon="mdi-close" @click="$emit('update:modelValue',false)"/>
                </v-card-title>
                <v-overlay :model-value="!formReady" contained class="align-center justify-center">
                    <v-progress-circular indeterminate color="primary"/>
                </v-overlay>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col class="py-0" cols="12" sm="12">
                            <v-select v-model="formData['monitoring_configs']"
                                      :items="monitoringConfigs"
                                      :rules="[vRules.required]" density="compact" item-title="name" item-value="id"
                                      label="Select Asset Monitoring Configuration" multiple>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-space-between">
                    <v-btn size="small" type="button" variant="outlined" @click="createDialogSwitch=true">
                        New Config
                    </v-btn>
                    <div>
                        <v-btn size="small" type="button" @click="$emit('update:modelValue',false)">
                            Close
                        </v-btn>
                        <v-btn color="primary" size="small" type="submit">Save</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>

    <Create-Config v-if="createDialogSwitch" v-model="createDialogSwitch" @addConfig="fetchMonitoringConfigList"/>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useLoadingStore} from "@/stores/loadingStore";
import {useSnackbarStore} from "@/stores/snackBarStore";
import CreateConfig from "@/components/dialogs/monitoring/configs/Create.vue";

const loadingStore = useLoadingStore();
const {showSnackbar} = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    asset: Object
});

const formData = reactive({
    valid: false,
    monitoring_configs: props.asset.monitoring_configs?.map(config => config.id) ?? [],
});

const formReady = ref(false);
const errors = ref([]);
const monitoringConfigs = ref([]);
const createDialogSwitch = ref(false);
const dialogSwitch = ref(props.modelValue);
const emits = defineEmits(['update:modelValue', 'updateAsset']);

onMounted(() => {
    Promise.all([fetchMonitoringConfigList()]).finally(() => formReady.value = true);
})
const fetchMonitoringConfigList = () => {
    if (props.asset.company_id) {
        monitoringConfigs.value = [];
        return send('get', `monitoring/configs`, {
            list: true,
            company: props.asset.company_id,
        }).then((response) => {
            monitoringConfigs.value = response.data.data;
        }).catch((error) => {
            console.log(error)
            showSnackbar('Monitoring configs could not be loaded', 'error')
        })
    }
    return Promise.resolve();
}
const updateAsset = () => {
    errors.value = [];
    loadingStore.showLoading('Updating...', 'Please wait while we save your changes');
    send('post', `assets/${props.asset.id}/monitoring-configs`, formData)
        .then((response) => {
            showSnackbar(response.data.message);
            if (response.data.success) {
                emits('updateAsset', response.data.data);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
        .finally(() => loadingStore.hideLoading());
}

</script>
